<template>
    <div class="u-full-height u-flex u-flex-col">
        <div class="mb-24">
            <h2 class="u-text-normal mb-12">Einstellungen</h2>
        </div>

        <div>
            <label for="backup-token">Backup-Token (<small>Das Token ist 1 Monat lang gültig</small>)</label>
            <input
                v-model="backupToken"
                id="backup-token"
                type="text"
                class="form-control mb-12"
                placeholder="Klicke 'Generieren' um ein Token zu generieren"
            >
            <app-button :is-loading="isLoadingBackupToken" @click.native="generateBackupToken">Generieren</app-button>

            <div class="mt-12">
                <small>Letzte 3 Backups:</small>
                <ul v-if="lastThreeBackups && lastThreeBackups.length" class="u-reset-list">
                    <li v-for="(backup, i) in lastThreeBackups" :key="`backup-timestamp-${i}`">
                        <small>- {{ backup }}</small>
                    </li>
                </ul>
                <small v-else>&nbsp;<em>Unbekannt</em></small>
            </div>
        </div>
    </div>
</template>

<script>
import AppButton from '@/components/ui/Button.vue'

export default {
    name: 'Settings',

    components: { AppButton },

    data: () => ({
        backupToken: null,
        isLoadingBackupToken: false,
        lastThreeBackups: [],
    }),

    mounted () {
        this.getLastThreeBackups()
    },

    methods: {
        async getLastThreeBackups () {
            try {
                const response = await this.$http.get(`${process.env.VUE_APP_API_BASE_URL}/get-last-backups`)
                if (response.data?.error) {
                    throw new Error(response.data.error)
                }

                this.lastThreeBackups = response?.data?.backups ?? []
            } catch (e) {
                console.log(e)
                this.$toast.open({ type: 'error', message: e.message })
            }
        },

        async generateBackupToken () {
            this.isLoadingBackupToken = true

            try {
                const response = await this.$http.get(`${process.env.VUE_APP_API_BASE_URL}/get-backup-token`)
                if (response.data?.error) {
                    throw new Error(response.data.error)
                }

                this.backupToken = response?.data ?? null
            } catch (e) {
                console.log(e)
                this.$toast.open({ type: 'error', message: e.message })
            } finally {
                this.isLoadingBackupToken = false
            }
        },
    },
}
</script>
